<template>
  <div class="homepage-root">
    <slot />
  </div>
</template>

<script setup>
// 홈페이지(PC 웹) 전용 스타일. 앱 스타일(style.css, style.scss)은 앱 레이아웃에서만 불러온다.
import "~/assets/css/styles.css";
</script>
